import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'replace',
  standalone: true,
})
export class ReplacePipe implements PipeTransform {
  transform(value: string, strToReplace: string, replacementStr: string): string {
    if (!value || !strToReplace) {
      return value;
    }
    // Ensure the string to replace is properly escaped for use in a RegExp
    const escapedStrToReplace = strToReplace.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    return value.replace(new RegExp(escapedStrToReplace, 'g'), replacementStr);
  }
}
